import CheckMark from "./component-library202.mjs";
import "./component-library203.mjs";
import normalizeComponent from "./component-library92.mjs";
const _sfc_main = {
  name: "ComparisonItemValues",
  components: { CheckMark },
  props: {
    title: { type: String, required: true },
    content: { type: String, default: "" },
    list: { type: Array, default: () => [] },
    additionalInfo: { type: String, default: "" },
    isChecked: { type: Boolean }
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("div", { staticClass: "comparison-item-values" }, [_c("strong", { staticClass: "comparison-item-values__title", attrs: { "aria-hidden": "true" } }, [_vm._v(_vm._s(_vm.title))]), _vm.content ? _c("div", { attrs: { "data-testid": "content", "aria-label": `${_vm.title}: ${_vm.content}` } }, [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v(_vm._s(_vm.content))])]) : _vm.isChecked ? _c("div", { attrs: { "data-testid": "isChecked" } }, [_c("CheckMark", { attrs: { "aria-label": `${_vm.title}: Ja.` } })], 1) : _vm.list.length > 0 ? _c("ul", { staticClass: "comparison-item-values__list", attrs: { "data-testid": "list", "aria-label": _vm.title } }, _vm._l(_vm.list, function(item, index) {
    return _c("li", { key: index }, [_vm._v(" " + _vm._s(item) + " ")]);
  }), 0) : _c("div", { attrs: { "data-testid": "notChecked", "aria-label": `${_vm.title}: Nein.` } }, [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("–")])]), _vm.additionalInfo ? _c("p", { attrs: { "data-testid": "additionalInfo" } }, [_vm._v(" " + _vm._s(_vm.additionalInfo) + " ")]) : _vm._e()]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "6224edbf",
  null,
  null
);
const comparisonItemValues = __component__.exports;
export {
  comparisonItemValues as default
};
